import { AvailabilityContent } from "PFApp/profiles/common/availability";
import { ProfileBookingsProvider } from "PFApp/profiles/common/profile_bookings_provider";
import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { useProfilePreviewData } from "PFApp/use_profile_preview";
import { isProfileActive } from "PFCore/helpers/profile";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useTranslation } from "react-i18next";

import useIsAvailabilityPermitted from "../../../use_is_availability_permitted";
import ViewInBookingModuleButton from "../../view_in_booking_module_button/view_in_booking_module_button";
import { ProfilePreviewAvailabilityActions } from "./profile_preview_availability_actions";
import css from "./profile_preview_avalability.module.scss";
import { ProfilePreviewHeader } from "./profile_preview_header";

export const ProfilePreviewAvailability = () => {
  const { t } = useTranslation("core");

  const {
    data: { profile, id, ready, showBookingButtons }
  } = useProfilePreviewData();

  const {
    data: { templates, availability }
  } = useMyAccountInfo();

  const isActive = isProfileActive(profile);
  const isAvailabilityPermitted = useIsAvailabilityPermitted(profile);
  const { canProfileCreateBooking } = useBookingModulePermissions();

  const canSeeBookingModule = canProfileCreateBooking(profile?.id);
  const canAddBooking = showBookingButtons && canSeeBookingModule && isActive;

  const isRenderable = ready && profile && profile.availability && isAvailabilityPermitted;
  // permissionsGroup check probably not needed because "ready" is taking care but left just in case
  if (!isRenderable || profile.permissionsGroup === undefined) {
    return null;
  }

  const actions = <ProfilePreviewAvailabilityActions canAddBooking={canAddBooking} profileId={id} />;

  return (
    <ProfileBookingsProvider
      templates={templates}
      profile={profile}
      bookingCategories={availability.booking_categories || []}
    >
      <div data-qa-id="ProfilePreviewAvailability">
        <ProfilePreviewHeader headerClassName={css.header} actions={actions}>
          <span>{t("profilePreview.availability")}</span>
          {canSeeBookingModule && <ViewInBookingModuleButton workforceMemberId={profile?.id} />}
        </ProfilePreviewHeader>
        <AvailabilityContent
          activeViews={["calendar"]}
          profile={profile}
          readOnly={true}
          isLoading={undefined}
          isAdmin={undefined}
          showTip={undefined}
        />
      </div>
    </ProfileBookingsProvider>
  );
};
